import React, { useState, useEffect } from 'react';
import { I18n } from 'react-polyglot';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './Contexts/AuthContext';
import ProtectedRoute from './Components/ProtectedRoute';
import Home from './Home';
import Quests from './Quests/Quests';
// import MyPoints from './MyPoints/MyPoints';
import Layout from './Layout/Layout'
import Login from './Login/Login'
import axios from 'axios';
import LocaleContext from './Contexts/LocaleContext';
//Normal way to route

function App() {
  const [locale, setLocale] = useState('en')
  const [messages, setMessages] = useState({})

  useEffect(() => {
    async function fetchData() {
      const result = await axios.get(`/translations/${locale}.json`)
      setMessages(result.data)
    }
    fetchData()
  }, [locale])

  useEffect(() => {
    document.documentElement.lang = locale; // Dynamically update the lang attribute
  }, [locale]);

  if (!Object.keys(messages).length) {
    return <div>Loading translations...</div>; // Render a loading state until translations are loaded
  }

  const handleMissingKey = (key) => {
    console.warn(`Missing translation for key: "${key}"`);
    return key; // Fallback to the key itself
  };

  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      <div>
        <I18n locale={locale} messages={messages} onMissingKey={handleMissingKey}>
          <Router>
            <AuthProvider>
              <Routes>
                <Route element={<Layout />}>
                  <Route element={<ProtectedRoute />}>
                    {/* <Route path="my-points" element={<MyPoints />} /> */}
                    <Route path="quests" element={<Quests />} />
                  </Route>

                  <Route index element={<Home />} />
                  <Route path="login" element={<Login />} />
                  <Route path="*" element={<Home />} />
                </Route>
              </Routes>
            </AuthProvider>
          </Router>
        </I18n>
      </div>
    </LocaleContext.Provider>
  );
}

export default App;



